import { gql } from '@apollo/client/core';

/**
 * Selections for the application config screens. Keep this in step with `AppConfig.ts` — every field
 * selected here is mapped there, and nothing more is selected than is mapped.
 *
 * One fragment rather than the list/detail pair `Internal/Account` needs: the index, the detail view
 * and the edit form all show the same seven fields, so a split would buy nothing and would let a list
 * row silently blank a loaded record.
 */
export const INTERNAL_APP_CONFIG_FIELDS = gql`
  fragment InternalAppConfigFields on AppConfig {
    id
    name
    applicationId
    appContext
    urlBase
    origin
    enforceOrigin
  }
`;
